import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService, ProviderService } from '../../api';

import { AvailiabilityJson } from '../../constants/comman.constants';
import { AvailabilityDays, Errors } from '../../interfaces';
import { DecryptFormatPipe } from '../../pipes';
import { SnackService } from '../../services';

@Component({
  selector: 'school-availability-form',
  templateUrl: './availability-form.component.html',
  styleUrls: ['./availability-form.component.scss'],
  providers: [DecryptFormatPipe]
})
export class AvailabilityFormComponent implements OnInit {

  @Input() timeSlots: string;
  @Input() queueSlots: string;
  @Input() cancelLink: string;
  @Input() AvailabilityIconPath: string;
  @Input() screen_type: string = 'provider';


  AvailiabilityJson: any = [{
    text: 'Monday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  },
  {
    text: 'Tuesday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  },
  {
    text: 'Wednesday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  },
  {
    text: 'Thursday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  },
  {
    text: 'Friday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  },
  {
    text: 'Saturday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  },
  {
    text: 'Sunday',
    day: null,
    timing: {
      "slot": [],
      "queue": []
    },
  }];
  // AvailiabilityJson: object[] = AvailiabilityJson;


  thisnow = new Date();
  todayDate = (this.thisnow.getMonth() + 1) + "/" + this.thisnow.getDate() + "/" + this.thisnow.getFullYear();

  availabilityFormValue: any = [];
  availabilityValue = {} as AvailabilityDays;
  errMsg = {} as Errors;
  slotVal: string = 'queue';

  provider_id: string;
  to_time: any = [];
  from_time: any = [];

  to_time_queue: any = [];
  from_time_queue: any = [];



  @ViewChild("availabilityForm", { static: false }) availabilitysForm: NgForm;

  constructor(
    private authService: AuthService,
    private _snackService: SnackService,
    private location: Location,
    private route: ActivatedRoute,
    private _decryptPipe: DecryptFormatPipe,
    private _route: Router,
    private _userService: ProviderService,
  ) {
    this.provider_id = this._decryptPipe.transform(this.route.snapshot.paramMap.get('providerId'));
  }

  ngOnInit(): void {
    this.provider_id = this._decryptPipe.transform(this.route.snapshot.paramMap.get('providerId'));

    this.provider_id = (this.provider_id).replace(/['"]+/g, '');

    this.getProvidersInfo(this.provider_id);
  }


  getProvidersInfo(Id: any): void {

    if (this.screen_type == 'provider') {
      this._userService.getProvidersInfo(Id).subscribe(
        result => {
          this.availabilityFormValue = result.body.data.providers.availabilities;
          if (result.body.data.providers.availabilities == null || result.body.data.providers.availabilities == '') {
            this.availabilityFormValue = [];
            this.availabilityFormValue = this.AvailiabilityJson;
          }

        }, error => {
          console.log(error);
        });
    }
  }

  checkTime(from_time, to_time) {
    var now = new Date();
    from_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + from_time;
    to_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + to_time;

    if (to_time > from_time) {
      return true;
    }
    else {
      return false;
    }
  }

  checkExists(from_time, to_time, timeVal): boolean {
    var now = new Date();
    from_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + from_time;
    to_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + to_time;

    let returnFlag = true;

    timeVal.forEach(function (value, key) {

      if (returnFlag) {
        var exist_fromtime = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + value.from_time;
        var exist_totime = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + value.to_time;

        if ((from_time > exist_fromtime && from_time < exist_totime) || (to_time >= exist_fromtime && to_time <= exist_totime)) {
          returnFlag = false;

        }

        if ((exist_fromtime > from_time && exist_fromtime <= to_time) || (exist_totime > from_time && exist_totime <= to_time)) {
          returnFlag = false;

        }

      }

    });
    return returnFlag;

  }

  addTimeSlots(j): void {


    if (this.from_time[j] == '' || this.from_time[j] == undefined) {

      this._snackService.openSnackBar("danger", "Please Enter From Time..");
    }
    else if (this.to_time[j] == '' || this.to_time[j] == undefined) {

      this._snackService.openSnackBar("danger", "Please Enter To Time..");
    } else {



      const checkTimeValid = this.checkTime(this.from_time[j], this.to_time[j]);
      const checkExistsValid = this.checkExists(this.from_time[j], this.to_time[j], this.availabilityFormValue[j]['timing']['slot']);

      if (checkTimeValid && checkExistsValid) {
        this.availabilityFormValue[j]['timing']['slot'].push({ "from_time": this.from_time[j], "to_time": this.to_time[j] });

        this.from_time[j] = null;
        this.to_time[j] = null;


        this.availabilityFormValue[j]['timing']['slot'].sort((a, b) => {
          var now = new Date();
          return new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + a.from_time).getTime() - new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + b.from_time).getTime();

        }
        )

      }
      else {

        if (checkTimeValid == false) {
          this._snackService.openSnackBar("danger", "Please give me a valid From Time and To Time...");
        } else {
          this._snackService.openSnackBar("danger", "The given time already exists!...");

        }

      }
    }

  }


  addQueueSlots(j): void {


    if (this.from_time_queue[j] == '' || this.from_time_queue[j] == undefined) {

      this._snackService.openSnackBar("danger", "Please Enter From Time..");
    }
    else if (this.to_time_queue[j] == '' || this.to_time_queue[j] == undefined) {

      this._snackService.openSnackBar("danger", "Please Enter To Time..");
    } else {



      const checkTimeValid = this.checkTime(this.from_time_queue[j], this.to_time_queue[j]);
      const checkExistsValid = this.checkExists(this.from_time_queue[j], this.to_time_queue[j], this.availabilityFormValue[j]['timing']['queue']);

      if (checkTimeValid && checkExistsValid) {
        this.availabilityFormValue[j]['timing']['queue'].push({ "from_time": this.from_time_queue[j], "to_time": this.to_time_queue[j] });

        this.from_time_queue[j] = null;
        this.to_time_queue[j] = null;


        this.availabilityFormValue[j]['timing']['queue'].sort((a, b) => {
          var now = new Date();
          return new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + a.from_time).getTime() - new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + b.from_time).getTime();

        }
        )

      }
      else {

        if (checkTimeValid == false) {
          this._snackService.openSnackBar("danger", "Please give me a valid From Time and To Time...");
        } else {
          this._snackService.openSnackBar("danger", "The given time already exists!...");

        }

      }
    }

  }

  removeTimeSlots(j, k): void {
    this.availabilityFormValue[j]['timing']['slot'].splice(k, 1);
  }

  removeQueueSlots(j, k): void {
    this.availabilityFormValue[j]['timing']['queue'].splice(k, 1);
  }

  onSubmit(): void {

    this.availabilityValue.provider_id = this.provider_id;

    this.authService.user.subscribe(user => {

      const timeval = user;
      this.availabilityFormValue.forEach(element => {
        element.tz = timeval.timezone.zone_name
      });
    });

    // const timeval = JSON.parse(localStorage.getItem('userData'));

    // this.availabilityFormValue.forEach(element => {
    //   element.tz = timeval.timezone.zone_name
    // });

    this.availabilityValue.availabilities = this.availabilityFormValue;

    const saveData = { ...this.availabilityValue };

    if (this.screen_type == 'provider') {
      this._userService.PatchProviders(saveData).subscribe(
        result => {
          this._snackService.openSnackBar("success", "Provider Availability Added Successfully!...");
          this.errMsg = {};

        }, error => {
          this._snackService.openSnackBar("danger", "Failed to add a new Provider..");
          this.errMsg = error.error.data.errors;
        });
    }
  }


  cancelClick() {
    this._route.navigate([this.cancelLink]);
  }

}

